module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-view"
  }, [_c('el-divider', {
    attrs: {
      "content-position": "center"
    }
  }, [_vm._v("系统信息")]), _vm._v(" "), _c('div', {
    staticClass: "app-title-view"
  }, [_vm._v("欢迎来到视频管理系统,当前登录用户:" + _vm._s(_vm.userData.userName) + ",当前登陆IP地址:" + _vm._s(_vm.userData.currentIp))]), _vm._v(" "), (_vm.$showMoreStatus) ? _c('div', {
    staticClass: "platform-text-view"
  }, [_vm._v("\n    " + _vm._s(_vm.platformItemText) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.$showMoreStatus) ? _c('div', {
    staticClass: "platform-view"
  }, _vm._l((_vm.platformItemList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "platform-item-view"
    }, [_c('div', {
      staticClass: "image-view"
    }, [_c('el-image', {
      staticStyle: {
        "width": "200px",
        "height": "200px"
      },
      attrs: {
        "src": item.imageUrl,
        "fit": "cover"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "text-view"
    }, [_vm._v("\n        " + _vm._s(item.itemText) + "\n      ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-chart-view"
  }, [_c('div', {
    staticClass: "chart-view"
  }, [_c('VisitCountChart')], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-view"
  }, [_c('UserRoleChart')], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "append-to-body": "",
      "visible": _vm.previewVisible,
      "title": "图片预览"
    },
    on: {
      "update:visible": function($event) {
        _vm.previewVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.previewImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f4328b0a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4328b0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/index.vue
// module id = 1325
// module chunks = 1